import { baseLocale, Locale } from '@/app/context/LocalizationContext';
import localConfig from '@/config';
import { QueryKeys } from '@/constants/queryKeys';
import { contentfulClient } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { CalendarSkeleton, CalendarEntry } from '../types';

const fectch = async () => {
  try {
    let content = [];

    if (localConfig.showContentLive) {
      content = (
        await contentfulClient.withAllLocales.getEntries<CalendarSkeleton, Locale>({
          content_type: 'governanceCalendar',
        })
      ).items;
    } else {
      content = (
        await axios.get<void, AxiosResponse<CalendarEntry[]>>(`${localConfig.contentfulUrl}/governanceCalendar.json`)
      ).data;
    }

    return content
      .map((entry) => {
        const { eventName, date, color } = entry.fields;

        return {
          eventName: eventName?.[baseLocale] || '',
          date: date?.[baseLocale] || '',
          color: color?.[baseLocale] || '#DFFE00',
        };
      })
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  } catch (e) {
    console.error(e);
    return;
  }
};

export const useGovernanceCalendar = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.GOVERNANCE_CALENDAR],
    queryFn: fectch,
    ...options,
  });
};

export type GovernanceCalendarDay = NonNullable<Awaited<ReturnType<typeof fectch>>>[number];
